/** Callout: inline, non-blocking notice with an icon per tone (information, caution, success, error). */
import { AlertTriangle, CheckCircle2, Info, XCircle } from 'lucide-react';
import type { ReactNode } from 'react';

export type CalloutTone = 'info' | 'warning' | 'success' | 'error';

const ICONS = { info: Info, warning: AlertTriangle, success: CheckCircle2, error: XCircle } as const;

export function Callout({
  tone = 'info',
  title,
  children,
  role,
  'data-testid': testId,
}: {
  tone?: CalloutTone;
  title?: ReactNode;
  children?: ReactNode;
  role?: 'status' | 'alert';
  'data-testid'?: string;
}) {
  const Icon = ICONS[tone];
  return (
    <div className="wdc-callout" data-tone={tone} role={role} data-testid={testId}>
      <Icon size={16} aria-hidden="true" />
      <div className="wdc-callout__body">
        {title ? (
          <p>
            <strong>{title}</strong>
          </p>
        ) : null}
        {children}
      </div>
    </div>
  );
}
